let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8MG8R")).then(() => parcelRequire('g52eJ'));